// extracted by mini-css-extract-plugin
export var pane = "pane-mobile-module--pane--5bb54";
export var trigger = "pane-mobile-module--trigger--4d88f";